import { TriggerCategory } from "@redotech/redo-model/shopper-agent/trigger-definition";
import * as z from "zod/v4";

export const bulkEnableShopperAgentCategory = {
  name: "bulkEnableShopperAgentCategory" as const,
  input: z.object({ categories: z.array(z.enum(TriggerCategory)).min(1) }),
  output: z.object({ success: z.boolean() }),
};
